import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Breadcrumbs as MUIBreadcrumbs, Typography } from '@mui/material';
import { styled } from '@mui/system';
import NavigateNextIcon from '@mui/icons-material/NavigateNext'

const StyledTypographyHover = styled(Typography)({
    textDecoration: 'none',
    color: 'inherit',
    cursor: 'default',
    '&:hover': {
        textDecoration: 'underline',
    },
});
const StyledTypography = styled(Typography)({
    textDecoration: 'none',
    color: 'inherit',
    cursor: 'default',
});

const StyledLink = styled(Link)({
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': {
        textDecoration: 'underline',
    },
});

const Breadcrumbs = ({ isChange, onIsModified }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const pathnames = location.pathname.split('/').filter((x) => x);

    // Get search parameters
    const searchParams = new URLSearchParams(location.search);
    const selectedCluster = searchParams.get('selectedCluster');

    const handleClusterClick = () => {
        if (!isChange) {
            navigate(`/secrets?selectedCluster=${selectedCluster}`);
        } else {
            onIsModified();
        }
    };

    const handleHomeClick = (e) => {
        e.preventDefault();
        if (!isChange) {
            navigate('/secrets');
        } else {
            onIsModified();
        }
    };

    return (
        <MUIBreadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
            <StyledLink to="/secrets" onClick={handleHomeClick}>
                Home
            </StyledLink>
            {pathnames.map((value, index) => {
                const to = `/${pathnames.slice(0, index + 1).join('/')}`;

                // Replace "view-secret" with the selected cluster name
                if ((value === 'view-secret' || value === 'update-secret') && selectedCluster) {
                    return (
                        <StyledTypographyHover
                            key={to}
                            onClick={handleClusterClick}
                            style={{ cursor: 'pointer' }}
                        >
                            {selectedCluster}
                        </StyledTypographyHover>
                    );
                }

                return index === pathnames.length - 1 ? (
                    <StyledTypography key={to}>
                        {value}
                    </StyledTypography>
                ) : (
                    <StyledLink to={to} key={to}>
                        {value}
                    </StyledLink>
                );
            })}
        </MUIBreadcrumbs>
    );
};

export default Breadcrumbs;
